export default __webpack_public_path__ + "static/media/background-vision.72bdffda.jpg";